<template>
  <section class="UpdateProfile" id="update-profile-page">
    <div class="page-banner orders-banner">
      <el-row>
        <el-col :lg="24">
          <div class="image">
            <img
              src="/img/page-banners/orders.jpg"
              alt="storeLocator-page-banner"
              class="img-fluid"
            />
            <div class="banner-cover">
              <div class="banner-cover-inner">
                <ul class="bredcums-list">
                  <li>
                    <router-link to="/">Home</router-link>
                  </li>

                  <li>
                    <router-link to="{name:'profile'}">Profile</router-link>
                  </li>
                </ul>
                <h3 class="bredcums-title">My Profile</h3>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <App-StoreFilter />
    </div>
    <section class="section-pad Profile-forms">
      <el-row type="flex" justify="center">
        <el-col :lg="12" :xs="20">
          <h3 class="form-title">Profile Details</h3>
          <el-form ref="form" :model="update_profile" label-position="top">
            <el-row :gutter="30">
              <el-col :md="24">
                <el-form-item label="Full Name">
                  <el-input v-model="update_profile.name"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :md="12">
                <el-form-item label="Last Name">
                  <el-input v-model="update_profile.last_name"></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
            <!-- <el-row :gutter="30">
              <el-col :md="12">
                <el-form-item label="Mobile Number">
                  <el-input v-model="update_profile.mobile"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Email ID">
                  <el-input v-model="update_profile.email"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row :gutter="30">
              <el-col :md="12">
                <el-form-item label="Gender">
                  <el-select v-model="update_profile.gender" placeholder="Select">
                    <el-option value="Male">Male</el-option>
                    <el-option value="Female">Female</el-option>
                    <el-option value="Transgender">Transgender</el-option>
                    <el-option value="Do not wish to disclose">Do not wish to disclose</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Date Of Birth">
                  <el-date-picker
                    :picker-options="datePickerOptions"
                    v-model="update_profile.dob"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    placeholder="Date of Birth"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-col :md="24">
              <el-form-item>
                <el-button type="primary" @click="onSubmit" :loading="loading" class="btn submit-btn">Update Profile</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
    </section>
  </section>
</template>

<script>
import AdminDefault from "@/layouts/AdminDefault";
import { mapGetters } from "vuex";


export default {
  name: "UpdateProfile",
  data() {
    return {
      loading: false,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        }
      },
      update_profile: {
        name: "",
        gender: "",
        dob: ""
      }
    };
  },
  computed: {
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("profile", ["getResponseStatus"]),
    ...mapGetters("auth", ["getAuthenticatedUser"])

  },
  created() {
    this.$emit("update:layout", AdminDefault);
    this.$root.$emit('closenav', false);
  },
  mounted() {
    this.$store.dispatch('errors/clear');
    this.update_profile.name = this.getAuthenticatedUser.name;
    this.update_profile.gender = this.getAuthenticatedUser.gender;
    this.update_profile.dob = this.getAuthenticatedUser.dob;
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      console.log(this.update_profile);
      await this.$store.dispatch('profile/updateProfile', this.update_profile);
      if(this.getResponseStatus && this.getResponseStatus.success) {
        this.loading = false;
        this.$notify.success({
            title: 'Success',
            message: this.getResponseStatus.message,
            type: 'success',
            offset: 150
          });
          await this.$router.push('/login');
      } 
      this.loading = false;
    }
  }
};
</script>


<style lang="scss">
</style>
